import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import jwt_decode from "jwt-decode";
import { NzMessageService } from 'ng-zorro-antd/message';
import { interval, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UtilsService } from 'src/app/utils/services/utils.service';
import { AuthenticationService } from '../../services/authentication.service';
import { ThemeConstantService } from '../../services/theme-constant.service';
import { HeaderService } from './header.service';
import { RemuneracionesExternalService } from 'src/app/pages/remunerations/remuneraciones-external.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class HeaderComponent implements OnInit{

    updateForm: FormGroup;

    searchVisible = false;
    quickViewVisible  = false;
    isFolded: boolean;
    isExpand: boolean;

    public adm = false;
    current_company = null;

    isVisible = false;
    isVisibleUpdate = false;
    isVisibleTos = false;
    selectedCompany = null;
    companies = [];

    userData = {
        companyName: '',
        fullName: '',
        email: ''
    };

    checkboxes = [
        { value: 'f29', label: 'Datos F29', checked: false },
        { value: 'f29_status', label: 'Estado F29', checked: false },
        { value: 'purchases', label: 'Compras', checked: false },
        { value: 'sales', label: 'Ventas', checked: false },
        { value: 'feeslips', label: 'Honorarios', checked: false },
        { value: 'affidavit', label: 'Declaraciones Juradas', checked: false },
        { value: 'rental', label: 'Estado de Renta', checked: false },
    ];

    periods = [
        {label: 'Enero - Marzo', value: ['01', '02', '03']},
        {label: 'Abril - Junio', value: ['04', '05', '06']},
        {label: 'Julio - Septiembre', value: ['07', '08', '09']},
        {label: 'Octubre - Diciembre', value: ['10', '11', '12']},
    ];

    selectedPeriod = [];
    selectedYear = null;

    years = [];

    errorYear = false;
    errorPeriod = false;

    open = false;

    services = {
        'purchases': 'compras',
        'sales': 'ventas',
        'feeslips': 'honorarios'
    };


    avatarUrl = '';

    today = new Date();

    isVisibleYear = true;
    isVisiblePeriod = true;

    radioValue = '';
    accepted_tos = false;
    checkTerms: Boolean = false;

    subscription: Subscription;

    intervalId;

    constructor(
        private themeService: ThemeConstantService,
        private headerService: HeaderService,
        private utilsService: UtilsService,
        private router: Router,
        private msg: NzMessageService,
        private fb: FormBuilder,
        private authenticationService: AuthenticationService,
        private remuneracionesService: RemuneracionesExternalService,
        ) {
            for (let i = this.today.getFullYear(); i >= this.today.getFullYear()-2; i--) {
                this.years.push(i);
            }
        }

    ngOnInit(): void {
        this.themeService.isMenuFoldedChanges.subscribe(isFolded =>
            this.isFolded = isFolded);
        this.themeService.isExpandChanges.subscribe(isExpand =>
            this.isExpand = isExpand);
        this.headerService.avatarUrl.subscribe(updatedAvatar =>
            this.avatarUrl = updatedAvatar);
        this.getProfile();
        this.buildForm();
        this.checkToken();
    }

    toggleFold() {
        this.isFolded = !this.isFolded;
        this.themeService.toggleFold(this.isFolded);
    }

    toggleExpand(exp: boolean) {
        this.isExpand = !exp ? exp : !this.isExpand
        this.isFolded = !this.isExpand;
        this.themeService.toggleExpand(this.isExpand);
        this.themeService.toggleFold(this.isFolded);
    }

    searchToggle(): void {
        this.searchVisible = !this.searchVisible;
    }

    quickViewToggle(): void {
        this.quickViewVisible = !this.quickViewVisible;
    }

    checkType(){
        this.isVisiblePeriod = (this.radioValue === 'rental') ? false : true;
    }

    getProfile(){
        this.headerService.getProfile()
		.subscribe(data => {

            localStorage.setItem('cc', JSON.stringify(data.pin_current_company));
            if (data['license'].length > 0){
                localStorage.setItem(
                    'license', JSON.stringify(data['license'][0]));
            }
            if (data['companies'].length > 0){
                console.log(data['companies']);
                localStorage.setItem(
                    'p', JSON.stringify(data.companies[0].id));
            }

            this.companies = data.companies;
            this.checkCurrentCompany(data);
			this.userData.fullName = data['full_name'];
            this.userData.companyName = data['pin_current_company']['code'] ?
                data['pin_current_company']['code'] + ' - '
                + data['pin_current_company']['name'] :
                data['pin_current_company']['name'];
            this.avatarUrl = data['avatar_small'];
            this.adm = data.admin;
		},
		err => {
            console.error('Error to get Transactions');
            console.error(err);
		});
    }

    checkCurrentCompany(user){
        if ((user.pin_current_company.id === undefined) && (!user.admin)){
            this.isVisible = true;
        } else {
            this.current_company = user.pin_current_company.id;
        }
    }

    chooseCompany(){
        this.getProfile();
        console.log("---------", this.selectedCompany)
        if (this.selectedCompany !== null){
            this.headerService.setCurrentCompany(this.selectedCompany)
            .subscribe(resp => {
                console.log("asdasda", resp)
                if (resp['result']['company_uuid']){
                    let current_data = JSON.parse(localStorage.getItem('currentUser'))
                    current_data['company_uuid'] = resp['result']['company_uuid']
                    current_data['company_rut'] = resp['result']['company_rut']

                    localStorage.setItem('currentUser', JSON.stringify(current_data))
                }
                // Precarga best-effort al cambiar de empresa activa, para que
                // Panel Resumen encuentre el cache ya tibio al entrar.
                this.remuneracionesService.preload();
                this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                this.router.onSameUrlNavigation = 'reload';
                this.router.navigate([
                    '/accounting-software-integration/balance']);
                this.isVisible = false;
            },
            err => {
                if (err.status === 401){
                    this.msg.error('Su sesión a expirado.');
                    this.router.navigate(['/login']);
                }
                console.error('Error to set company');
                console.error(err);
            });
        }else {
            this.msg.info('Debe seleccionar una empresa');
        }

    }

    buildForm() {
		this.updateForm = this.fb.group({
			planType : [ null, [Validators.required] ],
			planSubType : [ null, [Validators.required] ],
			ownPlanType : [ null, [Validators.required] ],
			ownPlan : [ null, [Validators.required] ],
		});
	}

    showModal(type: string){
        if (type === 'company'){
            this.isVisible = true;
        }else{
            this.isVisibleUpdate = true;
            this.open = true;
            this.isVisiblePeriod = true;
        }
    }

    hideModal(type: string){
        if (type === 'company'){
            if (this.current_company || this.adm){
                this.isVisible = false;
            }
        }else if (type === 'update'){
            this.isVisibleUpdate = false;
            this.radioValue = '';

        }
    }

    titleCase(str) {
        return this.utilsService.titleCase(str)
    }

    checkToken(){
        const source = interval(10000);
        const text = 'Your Text Here';
        this.subscription = source.subscribe(val => {
            this.getLastLogin();
        });
    }

    getLastLogin(){
        if (!environment.isApiReady) {
            return;
        }
        this.headerService.getLastLogin()
            .subscribe(data => {
                let currentUser;
                let decoded;
                currentUser = this.authenticationService.currentUserValue
                if (currentUser && currentUser.access){
                    decoded = jwt_decode(currentUser.access)
                    if (decoded['last_login'] !== data['last_login']){
                        this.msg.error(
                            'Se ha iniciado sesión en otro dispositivo.');
                        this.router.navigate(['/login']);
                        this.subscription.unsubscribe();
                    }
                }
            },
            err => {
                console.error('Error');
                console.error(err);
            });
    }

}
